import * as React from "react";
import type { SVGProps } from "react";
const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21.95 17.707 2.828-2.828a4 4 0 0 0 0-5.657v0a4 4 0 0 0-5.657 0l-2.828 2.828M12.05 16.293l-2.828 2.828a4 4 0 0 0 0 5.657v0a4 4 0 0 0 5.657 0l2.828-2.828M10.64 13.46l-2.12-.7M13.46 10.64l-.7-2.12M23.36 20.54l2.13.7M20.54 23.36l.7 2.13M14.17 19.83l5.66-5.66"
    />
  </svg>
);
export default SvgLink;
